import dynamic from "next/dynamic";

export const DynamicContent046 = dynamic(() => import("./Content046"), {
  suspense: true,
});
